import script from "./user-define-input-tool.vue?vue&type=script&lang=ts&setup=true"
export * from "./user-define-input-tool.vue?vue&type=script&lang=ts&setup=true"

import "./user-define-input-tool.vue?vue&type=style&index=0&id=45e27ea7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e27ea7"]])

export default __exports__